import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4a496fca")

_pushScopeId("data-v-4a496fca")
const _hoisted_1 = { class: "signup-privacy-policy" }
const _hoisted_2 = { class: "signup-privacy-policy__content" }
const _hoisted_3 = { class: "agree" }
const _hoisted_4 = { class: "p-field-checkbox" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", {
  for: "agree1",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" Consent to collection and use of personal information "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(REQUIRED)")
], -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<table class=\"-medium\" data-v-4a496fca><thead data-v-4a496fca><tr data-v-4a496fca><th data-v-4a496fca>Purpose of Collection/Use</th><th data-v-4a496fca>Items to Be Collected/Used</th><th data-v-4a496fca>Retention/Use Period</th></tr></thead><tbody data-v-4a496fca><tr data-v-4a496fca><td data-v-4a496fca><span data-v-4a496fca>Personal identification of an applicant, proceeding and managing the process of our service.</span></td><td data-v-4a496fca><span data-v-4a496fca>Personal identification information: picture, name, phone no. and e-mail address </span></td><td data-v-4a496fca><span data-v-4a496fca>Personal information above is retained and used for the aforementioned purposes from the date the user agrees to its collection/usage to the date that the user is decided. Provided, however, that after the date that the user is decided, the personal information will be retained and used only within the necessary scope for the resolution of dispute, and fulfillment of legal obligation. </span></td></tr></tbody></table>", 1)
const _hoisted_7 = { class: "agree" }
const _hoisted_8 = { class: "p-field-checkbox" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "agree2",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" Consent to use video during video consultation "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(REQUIRED)")
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, " For smooth prescription, doctors can save external body images such as lesions and wounds necessary for diagnosis during video consultation, and they are not used for purposes other than prescription. ", -1)
const _hoisted_12 = { class: "agree" }
const _hoisted_13 = { class: "p-field-checkbox" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "agree3",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" Confirm and agree to notices for membership registration "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(REQUIRED)")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "ps" }, [
  /*#__PURE__*/_createVNode("span", null, "Liability for false personal information or identity theft"),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("ol", null, [
      /*#__PURE__*/_createVNode("li", null, "1. If a member misrepresents personal information such as name, date of birth, passport number, etc. when signing up for membership, or steals other people's personal information, he/she may be subject to criminal punishment according to relevant laws and regulations."),
      /*#__PURE__*/_createVNode("li", null, "2. The company and medical institutions are not responsible for compensating the member for damages caused by using the service if the member uses this service by falsely entering personal information or stealing the identity of another person as in paragraph 1."),
      /*#__PURE__*/_createVNode("li", null, "3. If damages occur with the company or medical institution due to the member's false entry or identity theft, the member shall be liable for damages to the company and medical institution.")
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Checkbox, {
            id: "agree1",
            modelValue: _ctx.state.agree1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.agree1 = $event)),
            class: "-royalBlue check-box",
            binary: true
          }, null, 8, ["modelValue"]),
          _hoisted_5
        ]),
        _hoisted_6
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Checkbox, {
            id: "agree2",
            modelValue: _ctx.state.agree2,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.agree2 = $event)),
            binary: true,
            class: "-royalBlue check-box"
          }, null, 8, ["modelValue"]),
          _hoisted_9
        ]),
        _hoisted_10,
        _hoisted_11
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_Checkbox, {
            id: "agree3",
            modelValue: _ctx.state.agree3,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.agree3 = $event)),
            binary: true,
            class: "-royalBlue check-box"
          }, null, 8, ["modelValue"]),
          _hoisted_14
        ]),
        _hoisted_15,
        _hoisted_16
      ])
    ])
  ]))
})